import React, { useState, useEffect } from 'react';
import {
  Button,
  Typography,
  Avatar,
  theme,
  Layout,
  Switch,
  Tooltip
} from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  BellOutlined,
  BellFilled
} from '@ant-design/icons';

const { Title } = Typography;
const { Header } = Layout;

const AppHeader = ({ name, collapsed, setCollapsed, signOut }) => {
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);

  const {
    token: { colorBgContainer }
  } = theme.useToken();

  // Load the notification setting from localStorage when the component mounts
  useEffect(() => {
    const storedPreference = localStorage.getItem('notificationsEnabled');
    if (storedPreference !== null) {
      setNotificationsEnabled(JSON.parse(storedPreference));
    }
  }, []);

  const handleToggle = (checked) => {
    setNotificationsEnabled(checked);
    localStorage.setItem('notificationsEnabled', JSON.stringify(checked));
  };

  return (
    <Header
      style={{
        padding: '0 24px 0 0',
        background: colorBgContainer,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 8px #f0f1f2'
      }}
    >
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={() => setCollapsed(!collapsed)}
        style={{
          fontSize: '16px',
          width: 64,
          height: 64
        }}
      />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title="Teams Notifications">
          <Switch
            checkedChildren={<BellFilled />}
            unCheckedChildren={<BellOutlined />}
            checked={notificationsEnabled}
            onChange={handleToggle}
            style={{ marginRight: '16px' }}
          />
        </Tooltip>
        <Avatar
          style={{
            backgroundColor: '#87d068',
            marginRight: '8px'
          }}
          icon={<UserOutlined />}
        />
        <Title level={5} style={{ margin: '0 8px' }}>
          {name}
        </Title>
        <Button onClick={signOut} danger>
          Sign Out
        </Button>
      </div>
    </Header>
  );
};

export default AppHeader;
